import { createFileRoute } from "@tanstack/react-router";
import TableManagmentScreen from "../Screens/TableManagmentScreen";

export const Route = createFileRoute("/tables-management")({
  component: RouteComponent,
});

function RouteComponent() {
  return <TableManagmentScreen />;
}
